<template>
    <div id='app'>
        <slides nav-position='right' :slide-duration='0.75'>
            <section id='welcome'>
                <div class='content'>
                    <figure><img src='./assets/images/welcome.png'/></figure>
                    <div class='title'>
                        <h1>Ultimate Gamer</h1>
                        <p>Animation Development Proposal</p>
                        <button class='go-next black'>Continue</button>
                    </div>
                </div>
            </section>
            <section id='team'>
                <div class="logo">
                    <img src="./assets/images/logo-mt-vertical.svg" alt="Magical Threads"/>
                </div>
                <div class="logo">
                    <img src="./assets/images/logo-tb.png" alt="Tremblay Brothers"/>
                </div>
            </section>
            <section id='magical-threads-animation-studio'>
                <div class='title'>
                    <h2>Why Our Studio</h2>
                </div>
                <div class='content'>
                    <p>Authentic and organic fan engagement in animated properties &amp; storyworlds. IP with authenticity. Affect the human narrative in a positive way.</p>
                    <p>Experts in illustration, animation, studio projects, ip distribution, branding, content development, design, technology, and monetization.</p>
                    <p>Fans of our IP learn from the beginning that they can immerse themselves in and engage with these worlds daily.</p>
                    <p>We enable audiences to fall in love with the story and love that story back.</p>
                </div>
            </section>
            <section id='studio-partners'>
                <div class='title'>
                    <div class="logo">
                        <img src="./assets/images/logo-tb.png" alt="Tremblay Brothers"/>
                    </div>
                    <p class='large'>Christian &amp; Yvon Tremblay create cutting-edge original content and work with major properties like Looney Toons and Felix the Cat.</p>
                </div>
                <div class='content'>
                    <div class='highlights'>
                        <div class='sub-title'>
                            <h3>Highlights</h3>
                        </div>
                        <ul class='inner-content'>
                            <li>Worked with most top Hollywood Studios as independent creators-producers</li>
                            <li>Raised over $60M for slate of productions</li>
                            <li>Produced and broadcast in over 100 countries</li>
                            <li>Deep expertise in merchanzising and licensing</li>
                        </ul>
                    </div>
                    <div class='values'>
                        <div class='sub-title'>
                            <h3>Values</h3>
                        </div>
                        <div class='inner-content'>
                            <p><strong>Inspire</strong></p>
                            <p><strong>Educate</strong></p>
                            <p><strong>Create for Global Audiences</strong></p>
                        </div>
                    </div>
                </div>
            </section>
            <section id='where-we-develop'>
                <div class='content'>
                    <div class='title'>
                        <h2>Where We Develop</h2>
                    </div>
                    <p>New Chattanooga Location Pending</p>
                </div>
                <figure>
                    <img src='./assets/images/where-we-develop.png'/>
                </figure>
            </section>
            <section id='projects'>
                <div class='title'>
                    <h2>Projects</h2>
                </div>
                <div class='content'/>
            </section>

            <section id='proposal'>
                <div class='title'>
                    <h2>Proposal</h2>
                    <p class='large'>Thank you for your interest in developing <span class='underline'>Ultimate Gamer.</span></p>
                </div>
                <div class='content'>
                    <div class='sub-title'>
                        <h3>Output</h3>
                        <i class='c'/>
                    </div>
                    <ul class='inner-content'>
                        <li>TV Property Bible <sup>(incl. 10 story premises)</sup></li>
                        <li>Two Full Scripts</li>
                        <li>Main Cast Character Designs </li>
                        <li>Conceptual Background Designs </li>
                        <li>One 90 Second Animated Trailer <sup>(Full 3D CGI animation with SFX, Voices, Music)</sup></li>
                        <li>Marketing &amp; Sales Presentation Materials</li>
                        <li>Licensing &amp; Merchandizing Concepts</li>
                    </ul>
                </div>
            </section>

            <section id='development'>
                <div class='title'>
                    <h2>Development</h2>
                </div>
                <div class='content'>
                    <ul>
                        <li>6 Month Schedule</li>
                        <li>$300K Budget</li>    
                    </ul>
                </div>
            </section>
            
            <section id='development-schedule'>
                <div class='title'>
                    <h2>Development Schedule</h2>
                    <p class='large'>Timeline for 1 Piece of IP Development</p>
                </div>
                <div class='content'>
                    <Schedule/>
                </div>
            </section>

            <section id='the-full-picture'>
                <div class='title'>
                    <h2>The Full Picture</h2>
                </div>
                <div class='content'></div>
            </section>

            <section id='distribution-revenue-projections'>
                <div class='title'>
                    <h2>Distribution Revenue Projections</h2>
                    
                    <div class="inner-content">
                        
                        <div class='sub-title'><h3>Assumptions</h3></div>

                        <div class="flex">
                            <p>Weighted Avg on Market Revenues:</p>
                            <div class="data">
                                <div class="data-item">Conservative = 10%</div>    
                                <div class="data-item">Average = 80%</div>
                                <div class="data-item">Aggressive = 10%</div>
                            </div>
                            <p>Distribution Fees Applied:</p>
                            <div class="data">
                                <div class="data-item">Industry Standard = 25%</div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class='content'>
                    <div class="inner-content">
                        <div class='sub-title'>
                            <h3>3-5 Year Series Revenue</h3>
                        </div>
                        <p>TV Distribution <strong>5,903,239</strong></p>
                        <p>Home Video Distribution <strong>1,086,638</strong></p>
                    </div>
                    <div class='inner-content'>
                        <div class='sub-title'>
                            <h3>5-10 Year Rights Renewals</h3>
                        </div>
                        <p>Rights Renewals <strong>2,621,204</strong></p>
                    </div>
                </div>
            </section>

            <section id='estimated-roi'>
                <div class='title'>
                    <h2>Estimated Production ROI</h2>
                    <div class="inner-content">
                        <div class='sub-title'><h3>Assumptions</h3></div>
                        <div class="flex">
                            <p>Incentives:</p>
                            <div class="data">
                                <div class="data-item">37% Canadian Tax Credit</div>    
                            </div>

                            <p>Revenues Based On:</p>
                            <div class="data">
                                <div class="data-item">Sum of Int'l Distribution &amp; Rights Renewals</div>    
                            </div>

                            

                        </div>
                    </div>
                </div>
                <div class='content'>
                    <div class="grid-table">
                        <p class='label'>Estimated Production Cost</p>
                        <p class='amount'>$(9,000,000)</p>
                    
                        <p class='label'>Estimated Tax Credits</p>
                        <p class='amount'>$3,330,000</p>
                    
                        <p class='label'>Distribution Revenue Forecast</p>
                        <p class='amount'>$9,611,080</p>
                    
                        <p class='label'>Estimated NET</p>
                        <p class='amount'>$3,941,080</p>
                    </div>
                </div>
            </section>
            
            

            <section id='licensing-merchanzising'>
                <div class="title">
                    <h2>Licensing &amp; Merchandizing</h2>
                </div>
                <div class="content">
                    <LicensingMerchandising/>
                </div>
                <div class="data">
                    <p>Key Assumptions</p>
                    <p>Royalty Rate 10%</p>
                    <p>Agent Fee 35%</p>
                </div>
            </section>

            <section id='what-we-need'>
                <div class='title'>
                    <h2>What We Need To Get Going</h2>
                </div>
                <div class='content'>
                    <div class='icon bldg'/>
                    <div class='icon money'/>
                </div>
            </section>
            
            <section id='thank-you'>
                <div class='title'>
                    <h2>Thank You</h2>
                </div>
                <div class="content">
                    <figure><img src="./assets/images/logo-mt-vertical.svg" alt="Magical Threads"/></figure>
                    <figure><img src="./assets/images/logo-tb.png" alt="Tremblay Brothers"/></figure>
                </div>
            </section>
        </slides>
        <div id='slide-counter'><span>{{currentSlide + 1}} / {{totalSlides}}</span></div>
        <Logo/>
    </div>
</template>

<script>

import Slides from './Slides.vue'
import Logo from './components/Logo.vue'
import Schedule from './components/Schedule.vue'
import LicensingMerchandising from './components/LicensingMerchandising.vue'

export default {
    name: 'App',
    components: {
        'slides': Slides,
        'Logo': Logo,
        'Schedule': Schedule,
        'LicensingMerchandising': LicensingMerchandising
    },
    data() {
        return {
            currentSlide: 0,
            totalSlides: 0,
        }
    },
    methods: {
        updateCounter() {
            const slidesComponent = this.$children[0]
            slidesComponent.$on('slideEnd', event => this.currentSlide = event.currentIndex)
        }
    },
    mounted() {
        this.totalSlides = this.$el.querySelector('#slides article').children.length
        this.updateCounter()
    }
}
</script>

<style lang='scss'>

@import './styles/mixins';
@import './styles/fonts';
@import './styles/vars';
@import './styles/reset';

body {
    background: black;
    color: white;
    font-family: $font-regular;
    font-weight: 400;
    font-size: 16px;
    @include fluid-type(320px, 1920px, 12px, 24px);
}

h1, h2, h3 {
    font-family: $font-display-bold;
    font-weight: normal;
}

h1 {
    @include fluid-type(320px, 1920px, 48px, 122px);
    line-height: 1.05;
    margin: 0;
}

h2 {
    margin: 0;
    font-size: 3.5vw;
    line-height: 1;
}

.title h2.sep {
    position: relative;
    &::after {
        content: '';
        margin: 2.5vh 0 1.25vh;
        display: block;
        width: 30px;
        height: 6px;
        background: white;
    }
}

p {
    font-family: $font-regular;
    margin: 0 0 2.5vh;
    line-height: 1.42;
    &:last-of-type {
        margin: 0;
    }
    @include bp() {
        margin: 0 0 1vh;
    }
}

p.large {
    padding: 2.5vh 0;
    font-weight: 400;
    @include fluid-type(320px, 1920px, 14px, 32px);
    @include bp() {
        padding: 0.75vh 0;
    }
}

ul {
    list-style-type: square;
}

li:not(:last-of-type) {
    margin-bottom: 5vh;
    @include bp() {
        margin-bottom: 1.25vh;
    }
}

button {
    font-weight: 600;
    @include fluid-type(320px, 1920px, 10px, 14px);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 1.25vw 2.5vw;
    cursor: pointer;
    margin: 0 0 1em 0;
    transition: all 0.15s ease-out;
    border-radius: 2px;
    border: none;
    @include bp() {
        padding: 3.5vw 5.5vw;
    }
    &.black {
        color: white;
        background: black;
        &:hover {
            background: $color-gold;
            color: black;
        }
    }
    &.ghost {
        background: transparent;
        border: 1px solid white;
        color: white;
        &:hover {
            color: white;
            background: black;
            border: 1px solid black;
        }
    }
    &.orange {
        background: $color-orange;
        border: 1px solid transparent;
        color: black;    
        &:hover {
            color: white;
            background: black;
        }
    }
    &.gold {
        background: $color-gold;
        border: 1px solid transparent;
        color: black;
        &:hover {
            color: white;
            background: black;
        }
    }
}

/* 
    Logo
    --------------------------------------------------------
*/

#logo {
    position: fixed;
    top: 2.5vw; left: 2.5vw;
    width: 12vw;
    display: flex;
    align-items: center;
    margin: 0;
    z-index: 9002;
    fill: white;
    transition: all 0.3s linear;
    @include bp() {
        top: 6vw;
        left: 6vw;
        width: 50vw;
        .text {
            display: none;
        }
    }
}

.title,
.content {
    z-index: 1;
}

#welcome {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @include bg($color-blue);
    .content {
        position: relative;
        display: flex;
        width: 70%;
        align-items: center;
        @include bp() {
            flex-direction: column;
            text-align: center;
        }
    }
    .content > figure {
        width: 100%;
        height: 100%;
        position: relative;
        img {
            width: 100%;
            @include bp() {
                width: 60%;
                margin-bottom: 2.5vh;
            }
        }
    }
    .title {
        text-align: center;
        figure {
            display: inline-block;
            width: 35%; 
            margin: 0 0 2.5vh;
            @include bp() {
                width: 30%;
                margin-bottom: 2.5vh;
            }
        }
    }
    h1 {
        margin-bottom: 0;
    }
    p { margin: 0; }
    p:first-of-type {
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        margin: 0 0 1.5vh;
    }
    button {
        margin: 1.5vh 0 0 0;
    }
}



#welcome.active {
    .title * {
        opacity: 0;
        transform: translateY(10px);
    }
    figure {
        transform: scale(2, 1) translateY(-50%);
        filter: blur(5px);
        opacity: 0;
        transition: all 0s linear 0s;
    }
}

#welcome.active.complete {
    .title * {
        opacity: 1;
        transform: translateY(0px);
        transition: all 1s ease-out;
        @for $i from 1 through 3 {
            &:nth-child(#{$i}) {
                transition-delay: 0.3s * $i;
            }
        }
    }
    figure {
        transform: scale(1) translateY(0%);
        filter: blur(0px);
        opacity: 1;
        transition: all 0.7s $ease-out-bounce 0s;
    }
}

#welcome.complete {
    figure {
        transition: all 0s ease-in-out $slide-delay;
    }
}

[data-current='welcome'] {
    .nav-icon {
        fill: white;
    }
    + #slide-counter {
        span {
            opacity: 0;
        }
        + #logo {
            fill: white;
            opacity: 1;
        }
    }
}

#team {
    display: flex;
    padding: 0 10%;
    @include bp() {
        flex-direction: column;
        justify-content: center;
    }
    .logo {
        margin: 0;
        top: 0; left: 0;
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 85%;
            display: inline-block;
        }
        @include bp() {
            width: 100%;
            height: 30%;
        }
    }
    .logo:nth-of-type(1) img {
        width: 65%;
        opacity: 0.8;
    }
}

[data-current='team'] {
    .nav-icon {
        fill: white;
    }
    + #slide-counter {
        span {
            opacity: 0;
        }
        + #logo {
            fill: white;
            opacity: 0;
        }
    }
}

#team.active {
    .logo {
        opacity: 0;
        transition: all 0s linear 0s;
    }
}

#team.active.complete {
    .logo {
        opacity: 1;
        transition: all 0.3s ease-out 0s;
    }
}

#team.complete {
    .logo {
        transition-delay: $slide-delay;
    }
}


#magical-threads-animation-studio {
    position: relative;
    display: flex;
    align-items: center;
    background: lighten(black, 15%);
    @include bp() {
        flex-direction: column;
        justify-content: center;
    }
    .title {
        width: 50%;
        height: 75%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 0%;
        @include bp() {
            position: relative;
            width: auto;
            height: auto;
            align-items: flex-end;
            justify-content: flex-start;
            margin: 0 20px;
        }
    }
    .title h2 {
        text-align: right;
        width: 70%;
        line-height: 1.1;
        display: block;
        color: white;
        @include fluid-type(320px, 1920px, 32px, 122px);
        @include bp() {
            width: auto;
            text-align: left;
            margin-bottom: 1.5vh;
        }
    }
    .content {
        position: absolute;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 50%;
        z-index: 1;
        top: 0;
        bottom: 0;
        @include bp() {
            margin: 0 20px;
            position: relative;
            width: auto;
            height: auto;
            display: grid;
            grid-gap: 5px;
            grid-template-rows: 50% 50%;
            grid-template-columns: 50% 50%;
        }
        p {
            margin: 0.5vh 0;
            padding: 2.5% 10% 2.5% 5%;
            align-self: center;
            display: flex;
            align-items: center;
            position: relative;
            color: white;
            @include fluid-type(320px, 1920px, 12px, 30px);
            @include bp() {
                align-self: flex-start;
                padding: 10% 5% 5% 5%;
            }
        }
        p:nth-of-type(1) {
            border-left: 10px solid rgba($color-orange, 1);
            @include bp() {
                border-left: none;
                border-top: 6px solid rgba($color-orange, 1);
            }
        }
        p:nth-of-type(2) {
            border-left: 10px solid $color-gray;
            @include bp() {
                border-left: none;
                border-top: 6px solid $color-gray;
            }
        }
        p:nth-of-type(3) {
            border-left: 10px solid $color-gold;
            @include bp() {
                border-left: none;
                border-top: 6px solid $color-gold;
            }
        }
        p:nth-of-type(4) {
            border-left: 10px solid $color-green;
            @include bp() {
                border-left: none;
                border-top: 6px solid $color-green;
            }

        }
    }
}

[data-current='magical-threads-animation-studio'] {
    .nav-icon {
        fill: $color-gray;
        opacity: 0.4;
    }
    + #slide-counter {
        span {
            color: $color-gray;
            opacity: 0.4;
        }
        + #logo {
            fill: $color-gray;
            opacity: 0.4;
        }
    }
}

#studio-partners {
    position: relative;
    display: flex;
    color: black;
    justify-content: center;
    @include bp() {
        flex-direction: column;
        justify-content: flex-end;
    }
    .title {
        padding: 0 8vw;
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: black;
        @include bp() {
            padding: 0 15% 8%;
            width: 100%;
            justify-content: flex-end;
        }
    }
    .title .logo {
        margin-bottom: 5vh;
        @include bp() {
            margin-bottom: 3vh;
            img {
                width: 80%;
            }
        }
    }
    .title .logo img {
        width: 100%;
        display: block;
        @include bp() {
            width: 80%;
        }
    }
    .title h2 {
        line-height: 1;
        display: block;
        color: white;
        width: 70%;
        @include fluid-type(320px, 1920px, 32px, 122px);
        @include bp() {
            width: auto;
        }
    }
    .title h2.sep::after {
        background: $color-green;
    }
    p.large {
        margin: 0;
        display: flex;
        color: $color-gray;
        @include bp() {
            width: auto;
        }
    }
    .content {
        width: 50%;
        @include bp() {
            width: auto;
        }
    }
    .sub-title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }
    h3 {
        margin: 0;
        writing-mode: vertical-lr;
        color: $color-green;
        display: flex;
        align-items: center;
        @include fluid-type(320px, 1920px, 14px, 30px);
    }
    .highlights {
        height: 60%;
        @include bp() {
            height: auto;
        }
        background: darken($color-green, 5%);
        .sub-title {
            background: lighten(black, 20%);
        }
    }
    .values {
        height: 40%;
        @include bp() {
            height: auto;
        }
        background: darken($color-green, 10%);
        .sub-title {
            background: lighten(black, 10%);
        }
        .inner-content p strong {
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.1em;
        }
    }
    .highlights, .values {
        display: flex;
        position: relative;
        p, li {
            color: black;
        }
    }
    .values .inner-content,
    .highlights .inner-content {
        padding: 0vh 10% 0 10%;
        margin: 0;
        position: relative;
        width: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include bp() {
            padding: 2.5vh 10%;
        }
    }
}

[data-current='studio-partners'] {
    .nav-icon {
        fill: black;
        @include bp() {
            fill: $color-green;
        }
    }
    + #slide-counter {
        span {
            color: black;
        }
        + #logo {
            fill: $color-green;
        }
    }
}

#proposal {
    display: flex;
    align-items: center;
    color: white;
    flex-direction: column;
    .title {
        width: 100%;
        height: 40%;
        display: flex;
        padding: 0 15% 5vh;
        justify-content: flex-end;
        flex-direction: column;
        background: rgba($color-gray, 1);
        position: relative;
        z-index: 2;
        @include bp() {
            padding: 0 10% 5vh;
        }
    }
    .title h2 {
        @include fluid-type(320px, 1920px, 42px, 122px);
        color: black;
    }
    .title h2.sep::after {
        background: $color-blue;
    }
    p.large {
        color: black;
    }
    p.large .underline {
        font-weight: 800;
        display: inline-block;
    }
    .content {
        width: 100%;
        height: 60%;
        padding: 0 15%;
        display: flex;
        position: relative;
        @include bg($color-blue);
        @include bp() {
            flex-direction: column;
            padding: 10%;
    
        }
    }
    .content .sub-title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5vw;
        position: relative;
        @include bp() {
            margin: 0 0 2.5vh;
            padding: 0;
            display: block;
        }
    }
    .content .inner-content {
        width: 100%;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 100%;
        z-index: 1;
        margin: 0;
        padding: 0;
        @include bp() {
            width: 100%;
            p {
                width: 100%;
                padding: 0;
            }
        }
    }
    .content .inner-content p {
        @include fluid-type(320px, 1920px, 12px, 32px);
        color: white;
        font-weight: 600;
    }
    .content .sub-title h3 {
        @include fluid-type(320px, 1920px, 24px, 52px);
        margin: 0;
        color: white;
        background: darken(black, 0%);
        border-radius: 100%;
        width: 20vw;
        height: 20vw;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        position: relative;
        z-index: 2;
        @include bp() {
            width: auto;
            height: auto;
            border-radius: 0;
            background: none;
            display: block;
            text-align: left;
            margin: 0;
            padding: 0;
            color: black;
        }
    }
    .content li {
        margin: 0.75vh 0;
        line-height: 1.5;
        @include bp() {
            margin-bottom: 0.25vh;
        }
    }
    .content .sub-title .c {
        display: none;
        position: absolute;
        background: $color-orange;
        filter: hue-rotate(0deg) saturate(150%) brightness(111%) blur(60px);
        border-radius: 100%;
        width: 20vw;
        height: 20vw;
        transform: scale(1.25);
        z-index: 1;
    }
}

[data-current='proposal'] + #slide-counter {
    span {
        color: black;
    }
    + #logo {
        fill: black;
    }
}

#projects {
    background: black;
    display: flex;
    align-items: center;
    justify-content: center;
    @include bp() {
        flex-direction: column;
    }
    h2 {
        font-size: 20vw;
        color: lighten(black, 10%);
        @include bp() {
            font-size: 20vw;
            color: lighten(black, 15%);
        }
    }
    .title {
        position: absolute;
        left: 0; right: 0;
        text-align: center;
        top: 10vh;
        @include bp() {
            top: initial;
        }
    }
    .content {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url('./assets/images/projects.png') 50% 50%/contain no-repeat;
        @include bp() {
            height: 50%;
            background-position: 0% 50%;
            background-size: 250% auto;
            &:before {
                content: '';
                position: absolute;
                top: 0; bottom: 0; right: 0; left: 0;
                background: inherit;
                background-position: 100% 50%;
                background-size: 250% auto;
                transform: translateY(100%);
            }
        }
    }
}

[data-current='projects'] {
    .nav-icon {
        fill: white;
        opacity: 0.4;
    }
    + #slide-counter {
        span {
            color: white;
            opacity: 0.4;
        }
        + #logo {
            fill: white;
            opacity: 0.4;
        }
    }
}

#development-schedule {
    background: black;
    color: white;
    text-align: center;
    .title {
        position: absolute;
        top: 0; left: 0; right: 0;
        height: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        color: white;
        background: black;
        @include bp() {
            height: 40%;
            justify-content: flex-end;
            padding: 0 0 15%;
            &::after {
                content: 'Scroll Right' + "\2192";
                position: absolute;
                bottom: 2vh;
                right: 2vw;
                opacity: 0.35;
            }
        }
        h2 {
            font-size: 10vw;
            @include fluid-type(320px, 1920px, 36px, 60px);
        }
        p {
            color: $color-gray;
            padding: 0;
        }
    }

    .content {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 70%;
        background: white;
        color: black;
        @include bp() {
            cursor: move;
            height: 60%;
            overflow-x: auto;
            background-color: white;
            background-size: contain;
        }
    }
}

[data-current='development-schedule'] {
    .nav-icon {
        fill: white;
        opacity: 0.4;
    }
    + #slide-counter {
        span {
            color: black;
            opacity: 0;
        }
        + #logo {
            fill: white;
            opacity: 0.4;
        }
    }
}

#the-full-picture {
    background: white;
    display: flex;
    align-items: center;
    @include bp() {
        flex-direction: column;
    }
    .title,
    .content {
        height: 100%;
    }
    .title {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: black;
        color: white;
        width: 20%;
        @include bp() {
            height: 30%;
            width: 100%;
            align-items: flex-end;
            padding-bottom: 5vh;
        }
    }
    .content {
        background: url('./assets/images/roll-out-plan.png') 50% 50%/contain no-repeat;
        width: 80%;
        height: 80%;
        @include bp() {
            background-position: 100% 0%;
            height: 70%;
            width: 100%;
        }
    }
    .title h2 {
        writing-mode: tb;
        @include fluid-type(320px, 1920px, 30px, 72px);
        transform: rotate(180deg);
        @include bp() {
            transform: rotate(0deg);
            writing-mode: unset;
        }
    }
}


[data-current='the-full-picture'] {
    .nav-icon {
        fill: black;
        @include bp() {
            fill: white;
        }
    }
    + #slide-counter {
        span {
            color: black;
            opacity: 0;
        }
        + #logo {
            fill: white;
        }
    }
}

#estimated-roi {
     position: relative;
    display: flex;
    justify-content: center;
    @include bp() {
        flex-direction: column;
    }
    .title {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: $color-orange;
        z-index: 2;
        @include bp() {
            width: auto;
            height: 60%;
            position: relative;
            justify-content: flex-end;
            h3 {
                transform: rotate(180deg) !important;
            }
        }
    }
    .content {
        width: 50%;
        height: 100%;
        background: white;
        color: black;
        display: flex;
        align-items: center;
        @include bp() {
            width: auto;
            height: 40%;
        }
    }
    .grid-table {
        width: 100%;
        height: 100%;
        display: grid;
        grid-gap: 2px 0;
        grid-template-columns: 50% 50%;
        grid-template-rows: repeat(4, 1fr);
        .label {
            justify-content: flex-end;
            padding: 0 1.5vw 0 0;
            text-align: right;
            @include bp() {
            }
        }
        p {
            padding: 0 1vw;
            height: 100%;
            display: flex;
            align-items: center;
            align-self: center;
        }
        .label:nth-of-type(7),
        .amount:last-of-type {
            background: rgba($color-blue, 0.1);
        }
        .label:nth-of-type(1) {
            border-right: 6px solid $color-gray;
        }
        .label:nth-of-type(3) {
            border-right: 6px solid $color-gray;
        }
        .label:nth-of-type(5) {
            border-right: 6px solid $color-gray;
        }
        .label:nth-of-type(7) {
            border-right: 6px solid $color-blue;
        }

        .amount:last-of-type {
            font-size: 1.5em;
            font-weight: 800;
        }
    }
    .title h2 {
        height: 50%;
        display: flex;
        align-items: center;
        padding: 0 8%;
        @include bp() {
            height: auto;
            @include fluid-type(320px, 1920px, 30px, 72px);
            justify-content: flex-end;
            align-items: flex-end;
            margin-bottom: 5vh;
        }
    }
    .title .inner-content {
        height: 50%;
        width: 100%;
        background: rgba(black, 0.1);
        color: white;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10% 0 20%;
        @include bp() {
            padding: 5% 0;
            height: auto;
        }
    }
    .title .inner-content p {
        margin-bottom: 0;
        font-weight: 800;
    }
    .title .inner-content h3 {
        background: black;
        padding: 10px 5%;
        position: absolute;
        top: 0; left: 0;
        font-family: $font-regular;
        @include fluid-type(320px, 1920px, 14px, 24px);
        font-weight: 800;
        writing-mode: vertical-lr;
        height: 100%;
        text-align: center;
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title .inner-content h3 {
        transform: rotate(180deg);
    }
    .title .inner-content h3,
    .title .inner-content p {
        color: white;
    }
    .title .inner-content .flex {

    }
    .title .inner-content .data {
        display: flex;
        font-size: 0.85em;
        &:not(:last-of-type) {
            margin-bottom: 6vh;
        }
    }
    .title .inner-content .data-item {
        padding: 10px 0;
        margin: 0 10px 0 0;
        &:nth-of-type(1) {
            border-bottom: 3px solid $color-gold;
        }
        &:nth-of-type(2) {
            border-bottom: 3px solid $color-green;
        }
        &:nth-of-type(3) {
            border-bottom: 3px solid $color-orange;
        }
    }
    .title .inner-content .data:last-of-type .data-item {
        border-bottom: 3px solid rgba($color-gray, 0.5);
    }
    h3 {
        @include fluid-type(320px, 1920px, 24px, 36px);
        margin: 0 0 1.5vh;

        color: black;
    }
    p {
        margin: 0;
    }
    li {
        margin: 0 0 0 20%;
        padding: 2.5% 0%;
    }
}

[data-current='estimated-roi'] {
    .nav-icon {
        fill: black;
        @include bp() {
            fill: white;
        }
    }
    + #slide-counter {
        span {
            color: black;
            opacity: 0;
        }
        + #logo {
            fill: white;
        }
    }
}

#distribution-revenue-projections {
    position: relative;
    display: flex;
    justify-content: center;
    background: $color-blue;
    @include bp() {
        flex-direction: column;
        justify-content: flex-end;
    }
    .title {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: $color-blue;
        justify-content: flex-end;
        z-index: 2;
        @include bp() {
            width: 100%;
            height: auto;
            position: relative;
            display: flex;
            flex-direction: column;

        }
    }
    .content {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        @include bp() {
            width: auto;
            height: auto;
        }
    }
    .title h2 {
        height: 50%;
        display: flex;
        align-items: center;
        padding: 0 8%;
        @include bp() {
            display: block;
            height: auto;
            @include fluid-type(320px, 1920px, 32px, 48px);
            margin-bottom: 2.5vh;
        }
    }
    .title .inner-content {
        height: 50%;
        width: 100%;
        background: rgba(black, 0.1);
        color: white;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        @include bp() {
            height: auto;
            padding: 5% 0;
        }
    }
    .title .inner-content p {
        margin-bottom: 0;
        font-weight: 800;
    }
    .title .inner-content h3 {
        background: black;
        padding: 10px 5%;
        position: absolute;
        top: 0; left: 0;
        font-family: $font-regular;
        @include fluid-type(320px, 1920px, 14px, 24px);
        font-weight: 800;
        writing-mode: vertical-lr;
        height: 100%;
        text-align: center;
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title .inner-content h3 {
        transform: rotate(180deg);
    }
    .title .inner-content h3,
    .title .inner-content p {
        color: white;
    }
    .title .inner-content .flex {
        width: 90%;
        padding-left: 10%;
    }
    .title .inner-content .data {
        display: flex;
        font-size: 0.85em;
        &:not(:last-of-type) {
            margin-bottom: 6vh;
        }
    }
    .title .inner-content .data-item {
        padding: 10px 0;
        margin: 0 10px 0 0;
        &:nth-of-type(1) {
            border-bottom: 3px solid $color-gold;
        }
        &:nth-of-type(2) {
            border-bottom: 3px solid $color-green;
        }
        &:nth-of-type(3) {
            border-bottom: 3px solid $color-orange;
        }
    }
    .title .inner-content .data:last-of-type .data-item {
        border-bottom: 3px solid rgba($color-gray, 0.5);
    }
    h3 {
        @include fluid-type(320px, 1920px, 24px, 36px);
        margin: 0 0 1.5vh;
        color: black;
    }
    .content .inner-content {
        margin: 0;
        padding: 10%;
        position: relative;
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        @include bp() {
            padding: 10% 10%;
            height: auto;
            h3 {
                @include fluid-type(320px, 1920px, 14px, 24px);
            }
        }
        &:nth-of-type(1) {
            background: lighten($color-gray, 10%);
            color: black;
        }
        &:nth-of-type(2) {
            background: rgba($color-gray, 1);
            color: black;
        }
        p {
            display: grid;
            grid-template-columns: 50% 50%;
        }
    }
    p {
        margin: 0;
    }
    li {
        margin: 0 0 0 20%;
        padding: 2.5% 0%;
    }
}

[data-current='distribution-revenue-projections'] {
    .nav-icon {
        fill: $color-blue;
        @include bp() {
            fill: white;
        }
    }
    + #slide-counter {
        span {
            color: black;
            opacity: 0;
        }
        + #logo {
            fill: white;
        }
    }
}


#licensing-merchanzising {
    background: white;
    color: black;
    .title {
        height: 30%;
        text-align: center;
        justify-content: center;
        display: flex;
        align-items: center;
        @include bp() {
            position: relative;
            &::after {
                content: 'Scroll Right' + "\2192";
                position: absolute;
                bottom: 2vh;
                right: 2vw;
                opacity: 0.35;
            }
        }
    }
    .title h2 {
        @include fluid-type(320px, 1920px, 24px, 60px);
    }
    .content {
        height: 55%;
        @include bp() {
            cursor: move;
            overflow-x: auto;
            background-color: white;
            background-size: contain;
        }
    }
    .data {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 300px;
        display: flex;
        align-items: center;
        height: 15%;
        font-size: 0.85em;
        @include bp() {
            left: 0;
            right: 0;
            padding: 10%;
        }
        p {
            font-size: 0.85em;  
            margin: 0;
            margin-right: 2vw;
        }
    }
    .row .item:nth-of-type(odd), {
        filter: saturate(0);
        font-weight: normal;
    }
}

[data-current='licensing-merchanzising'] {
    .nav-icon {
        fill: black;
    }
    + #slide-counter {
        span {
            color: black;
            opacity: 0;
        }
        + #logo {
            fill: black;
        }
    }
}

#where-we-develop {
    background: white;
    color: black;
    display: flex;
    @include bp() {
        flex-direction: column-reverse;
    }
    .content {
        width: 50%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 0 0 8%;
        @include bp() {
            width: auto;
            padding: 8%;
            height: 30%;
            justify-content: flex-start;
        }
    }
    figure {
        position: relative;
        width: 50%;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        @include bg($color-gold);
        @include bp() {
            top: initial;
            height: 70%;
            width: 100%;
        }
        img {
            display: block;
            width: 70%;
            z-index: 1;
            @include bp() {
                width: auto;
                height: 90%;
            }
        }
    }

    .title h2 {
        @include fluid-type(320px, 1920px, 30px, 92px);
        margin-bottom: 5vh;
        color: $color-blue;
        color: black;
        @include bp() {
            margin-bottom: 2.5vh;
        }
    }
    .content p {
        width: 75%;
        @include bp() {
            width: auto;
        }
    }
}

[data-current='where-we-develop'] {
    .nav-icon {
        fill: black;
    }
    + #slide-counter {
        span {
            color: black;
        }
        + #logo {
            fill: black;
        }
    }
}

#thank-you {
    background: black;
    
    .title {
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: lighten(white, 0%);
        align-items: center;
        padding: 5% 10% 0;
        @include bp() {
            height: 33.33%;
        }
        img {
            width: 20%;
        }
    }
    .title h2 {
        position: relative;
        bottom: 0;
        color: black;
        @include fluid-type(320px, 1920px, 48px, 60px);
        left: 0;
        line-height: 0.5;
        margin: 0;
    }
    .content {
        height: 50%;
        margin: auto;
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: 100%;
        @include bp() {
            height: 66.66%;
            grid-template-columns: 100%;
            grid-template-rows: 50% 50%;
        }
    }
    .content figure {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .content figure:nth-of-type(1) {
        background: lighten(black, 8%);
        img {
            width: 40%;
            display: block;
        }
    }
    .content figure:nth-of-type(2) {
        background: lighten(black, 10%);
        img {
            width: 50%;
            display: block;
        }
    }
}

[data-current='thank-you'] {
    .nav-icon {
        fill: $color-gray;
        opacity: 1;
    }
    + #slide-counter {
        span {
            color: $color-gray;
            opacity: 0.4;
        }
        + #logo {
            fill: $color-gray;
            opacity: 1;
        }
    }
}

#new-developments {
    background: lighten(black, 10%);
    .title {
        width: 60%;
        height: 50%;
        display: flex;
        align-items: center;
        color: white;
        padding: 0 5%;
        @include bp() {
            padding: 8% 10%;
            width: auto;
            align-items: flex-end;
            background: lighten(black, 15%);
        }
        h2 {
            @include fluid-type(320px, 1920px, 36px, 72px);
        }
    }
    .content {
        height: 50%;
        display: grid;
        grid-gap: 20px;
        grid-template-columns: repeat(3, 1fr);
        margin: 0 5%;
        @include bp() {
            padding: 10%;
            margin: 0;
            grid-gap: 10px;
            grid-template-columns: none;
            grid-template-rows: repeat(3, 1fr);
        }
        p:nth-of-type(1) {
            border-top: 10px solid $color-blue;
            @include bp() {
                border-top: none;
                border-left: 6px solid $color-blue;
            }
        }
        p:nth-of-type(2) {
            border-top: 10px solid $color-cyan;
            @include bp() {
                border-top: none;
                border-left: 6px solid $color-cyan;
            }
        }
        p:nth-of-type(3) {
            border-top: 10px solid $color-gold;
            @include bp() {
                border-top: none;
                border-left: 6px solid $color-gold;
            }
        }
        p {
            padding-top: 5vh;
            @include fluid-type(320px, 1920px, 14px, 30px);
            height: 100%;
            display: flex;
            font-weight: 600;
            align-items: flex-start;
            padding: 10%;
            color: white;
            position: relative;
            @include bp() {
                padding: 0 0 0 5%;
                display: flex;
                align-items: center;
                margin: 0;
            }
            &:before {
                z-index: -1;
            }
        }
    }
}

[data-current='new-developments'] {
    .nav-icon {
        fill: white;
        opacity: 0.4;
    }
    + #slide-counter {
        span {
            color: $color-gray;
            opacity: 0.4;
        }
        + #logo {
            fill: white;
            opacity: 0.4;
        }
    }
}

#why-chattanooga {
    display: flex;
    @include bp() {
        flex-direction: column;
    }
    .title {
        display: flex;
        flex-direction: column;
        padding: 0;
        text-align: center;
        width: 50%;
        justify-content: center;
        position: relative;
        align-items: center;
        @include bp() {
            width: auto;
            height: 40%;
        }
    }
    .title h2 {
        position: relative;
        top: 1vh;
        @include fluid-type(320px, 1920px, 32px, 92px);
        width: 75%;
        @include bp() {
            width: 80%;
            left: 0;
            text-align: left;
            top: 2vh;
        }
    }
    .content {
        width: 50%;
        display: grid;
        grid-template-rows: 50% 50%;
        grid-template-columns: 50% 50%;
        @include bp() {
            width: auto;
            height: 60%;
        }
    }
    .content p {
        align-self: center;
        justify-self: center;
        margin: 0;
        height: 100%;
        width: 100%;
        padding: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        text-align: center;
        color: black;
        &:before {
            content: '';
            position: absolute;
            width: 3vw;
            height: 3vw;
            z-index: 1;
            background: white;
            @include bp() {
                width: 5vw;
                height: 5vw;
            }
        }
    }
    .content p:nth-of-type(1) { 
        background: darken(white, 7%); 
        &:before {
            background: $color-gray;
            bottom: 0;
            right: 0; 
        }
    }
    .content p:nth-of-type(2) { 
        background: darken(white, 9%);
        &:before {
            background: $color-orange;
            bottom: 0;
            left: 0; 
        }
    }
    .content p:nth-of-type(3) {
        background: darken(white, 11%);
        &:before {
            background: $color-green;
            top: 0;
            right: 0; 
        }
    }
    .content p:nth-of-type(4) {
        background: darken(white, 13%);
        &:before {
            background: $color-gold;
            top: 0;
            left: 0; 
        }
    }
    figure {
        margin: 0;
        background: black;
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        display: flex;
        align-items: flex-end;
        z-index: -1;
        &:before {
            content: '';
            opacity: 0.4;
            position: absolute;
            top: 0; right: 0; bottom: 0; left: 0;
            background: url('./assets/images/why-chattanooga.jpg') 50% 50%/cover no-repeat;
            z-index: -1;
        }
    }
}

[data-current='why-chattanooga'] {
    .nav-icon {
        fill: black;
        @include bp() {
            fill: white;
        }
    }
    + #slide-counter {
        span {
            color: black;
        }
        + #logo {
            fill: white;
        }
    }
}

#what-we-need {
    .title {
        height: 50%;
        padding: 8%;
        display: flex;
        align-items: flex-end;
        width: 100%;
        background: $color-gray;
        @include bp() {
            width: auto;
        }
    }
    h2 {
        color: black;
        @include fluid-type(320px, 1920px, 36px, 72px);
        @include bp() {
            @include fluid-type(320px, 1920px, 36px, 122px);
        }
    }
    .content {
        height: 50%;
        color: white;
        padding: 0;
        display: grid;
        grid-gap: 0;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: 100%;
        @include bp() {
            grid-template-columns: 50% 50%;
            grid-template-rows: 100%;
        }
        .icon.bldg {
            background: $color-blue url('./assets/images/what-we-need-1.png') 50% 50%/50% auto no-repeat;
        }
        .icon.money {
            background: $color-green url('./assets/images/what-we-need-2.png') 50% 50%/50% auto no-repeat;
        }
        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            @include bp() {
                background-size: 70% auto !important;
            }
        }   
    }
}

[data-current='what-we-need'] {
    .nav-icon {
        fill: black;
    }
    + #slide-counter {
        span {
            color: black;
        }
        + #logo {
            fill: black;
        }
    }
}

#development {
    background: $color-green;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
        display: flex;
        align-items: center;
        padding: 0 10%;
        background: black;
        width: 100%;
        height: 50vh;
        @include bp() {
            align-items: center;
            position: relative;
            left: 0;
            justify-content: center;
            width: 100%;
            height: 50vh;
            padding: 10%;
        }
    }
    .title h2 {
        @include fluid-type(320px, 1920px, 32px, 92px);
    }
    .content {
        position: relative;
        left: 0;
        display: flex;
        align-items: center;
        padding: 0;
        background: $color-orange;
        color: white;
        width: 100%;
        height: 50vh;
        @include bp() {
            align-items: flex-start;
            width: 100%;
            height: 50vh;
            padding: 10%;
            top: 0;
            left: 0;
            border-radius: 0;
            padding: 0;
        }
    }
    .content ul {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        list-style: none;
        @include bp() {
            display: block;

        }
    }
    .content li {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        margin: 0;
        @include fluid-type(320px, 1920px, 24px, 30px);
        @include bp() {
            width: 100%;
            display: flex;
            height: 50%;
        }
    }
    .content li:nth-of-type(1) {
        background: darken($color-orange, 5%);
    }
}

[data-current='development'] {
    .nav-icon {
        fill: white;
    }
    + #slide-counter {
        span {
            color: white;
        }
        + #logo {
            fill: white;
        }
    }
}

/* 
    Counter
    --------------------------------------------------------
*/

#slide-counter {
    position: fixed;
    bottom: 2.5vh; right: 2.5vw;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    @include fluid-type(320px, 1920px, 10px, 12px);
    z-index: 9000;
    @include bp() {
        display: none;
    }
    span {
        font-weight: 800;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        border-radius: 40px;
        color: black;
        transition: all 0.3s ease-in-out;
    }
}

</style>


// WEBPACK FOOTER //
// src/App.vue